module.exports = __webpack_public_path__ + "static/007457-f339e92439b7ed3573b927969650102e.jpg";